import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Tooltip } from '@mui/material';
import PaletteIcon from '@mui/icons-material/Palette';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { SET_THEME_MODE } from 'store/actions';

const ThemeToggle = () => {
    const dispatch = useDispatch();
    const themeMode = useSelector((state) => state.customization.themeMode);
    const isNeu = themeMode === 'neumorphic';

    const toggle = () => {
        dispatch({ type: SET_THEME_MODE, themeMode: isNeu ? 'classic' : 'neumorphic' });
    };

    return (
        <Tooltip title={isNeu ? 'Switch to Classic theme' : 'Switch to Neumorphic theme'} placement="bottom">
            <IconButton onClick={toggle} size="large" sx={{ marginLeft: 1 }}>
                {isNeu ? <PaletteIcon /> : <AutoAwesomeIcon />}
            </IconButton>
        </Tooltip>
    );
};

export default ThemeToggle;
